import cx from "classnames";
import { PlusIconSvg } from "components/icons";
import { MinusIconSvg } from "components/icons/MinusIconSvg";
import { QuantitySelectorRemoveSvg } from "components/icons/QuantitySelectorRemoveSvg";
import { FC } from "react";

type QuantitySelectorProps = {
  allowRemoveButton?: boolean;
  disabled: boolean;
  maxQty: number;
  outOfStock: boolean;
  quantity: number;
  title?: string | null;
  updateQty: (quantity: number, isIncrese?: boolean) => Promise<void>;
};

export const QuantitySelector: FC<QuantitySelectorProps> = ({
  allowRemoveButton = true,
  disabled,
  maxQty,
  outOfStock,
  quantity,
  title,
  updateQty,
}) => {
  const isIncreaseDisabled = quantity >= maxQty || outOfStock || disabled;
  const isDecreaseDisabled = (!allowRemoveButton && quantity <= 1) || disabled;
  const showRemove = allowRemoveButton && (outOfStock || quantity === 1);

  return (
    <div>
      {title && (
        <div className="pb-[8px] text-blue-950 text-sm font-bold">{title}</div>
      )}
      <div className="flex items-center gap-1">
        <div
          onClick={() => {
            if (outOfStock) {
              updateQty(0);
            } else {
              updateQty(quantity - 1);
            }
          }}
          className={cx(
            "w-12 h-12 p-3 rounded-[100px] border border-blue-950 justify-center items-center inline-flex cursor-pointer",
            showRemove && "border-red-400",
            isDecreaseDisabled &&
              "cursor-not-allowed pointer-events-none border-gray-300",
          )}
        >
          {showRemove ? (
            <QuantitySelectorRemoveSvg />
          ) : (
            <MinusIconSvg color={isDecreaseDisabled ? "#CCCCCC" : "#13294B"} />
          )}
        </div>
        <div className="w-12 h-12 flex-col justify-center items-center inline-flex">
          <p className="text-blue-950 text-base font-semibold leading-[21px]">
            {quantity}
          </p>
        </div>
        <div
          onClick={() => updateQty(quantity + 1, true)}
          className={cx(
            "w-12 h-12 p-3 rounded-[100px] border border-blue-950 justify-center items-center inline-flex cursor-pointer",
            isIncreaseDisabled &&
              "cursor-not-allowed pointer-events-none border-gray-300",
          )}
        >
          <PlusIconSvg color={isIncreaseDisabled ? "#CCCCCC" : "#13294B"} />
        </div>
      </div>
    </div>
  );
};
